import { FileType } from '@office-start/document-types';
import { logErrorEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { LogCategory, TraceLevel, } from '@office-start/owl-proxy';
import { getRequestIdFromResponse, httpPost } from '@office-start/xhr-service';
var myDriveEndpoint = 'me/drive/';
var myOneNoteEndpoint = 'me/onenote/';
// TODO: This uses Graph service and should be move to graph-service package
export function createNewFile(vroomApiOptions, filename, fetchOpenWithData, fileType, selectParams, logger) {
    var jwtAuthEnabled = vroomApiOptions.jwtAuthEnabled, getAccessToken = vroomApiOptions.getAccessToken, officeHomeApiRoot = vroomApiOptions.officeHomeApiRoot, correlationId = vroomApiOptions.correlationId;
    /**
     * @deprecated Utilize createNewNotebook.ts operation instead till refactoring for this is sorted out
     */
    if (fileType === FileType.OneNote) {
        var url = "https://graph.microsoft.com/v1.0/".concat(myOneNoteEndpoint, "notebooks");
        var postBody = {
            displayName: filename,
        };
        var createNewRequestConfig = {
            headers: { 'Content-Type': 'application/json' },
        };
        return httpPost(KnownInstrumentationEvents.OneDriveGraphCreateFileRequest, "OneDrive_Graph_Create_File" /* KnownRequestInstrumentationEvents.OneDriveGraphCreateFileRequest */, url, JSON.stringify(postBody), createNewRequestConfig, jwtAuthEnabled !== null && jwtAuthEnabled !== void 0 ? jwtAuthEnabled : false, getAccessToken, officeHomeApiRoot, correlationId, 'Graph', {
            populateRequestEvent: function (response, params) {
                params["RequestId" /* InstrumentationParam.RequestId */] =
                    getRequestIdFromResponse(response) || '';
            },
        }).then(function (response) {
            var item = response.data;
            if (item &&
                item.links &&
                item.links.oneNoteWebUrl &&
                item.links.oneNoteWebUrl.href) {
                return item;
            }
            else {
                throw logErrorEvent('Could not parse drive item from Graph response');
            }
        }, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (error) {
            var _a;
            var params = (_a = {},
                _a["ResourceId" /* InstrumentationParam.ResourceId */] = correlationId,
                _a["Error" /* InstrumentationParam.Error */] = error,
                _a);
            logErrorEvent(KnownInstrumentationEvents.WacDocumentVroomError, params);
            return undefined;
        });
    }
    else {
        var url = undefined;
        if (selectParams && selectParams.length) {
            url = "https://graph.microsoft.com/v1.0/".concat(myDriveEndpoint, "root/children?").concat('select=' + selectParams.join(','), ",*");
        }
        else {
            url = "https://graph.microsoft.com/v1.0/".concat(myDriveEndpoint, "root/children?select=webDavUrl,").concat(fetchOpenWithData ? 'openwith,' : '', "*");
        }
        var postBody = {
            name: filename,
            file: {},
            '@microsoft.graph.conflictBehavior': 'rename',
        };
        var createNewRequestConfig = {
            headers: {
                'Content-Type': 'application/json',
                Prefer: 'allow-zerobyte',
            },
        };
        return httpPost(KnownInstrumentationEvents.OneDriveGraphCreateFileRequest, "OneDrive_Graph_Create_File" /* KnownRequestInstrumentationEvents.OneDriveGraphCreateFileRequest */, url, JSON.stringify(postBody), createNewRequestConfig, jwtAuthEnabled !== null && jwtAuthEnabled !== void 0 ? jwtAuthEnabled : false, getAccessToken, officeHomeApiRoot, correlationId, 'Graph', {
            populateRequestEvent: function (response, params) {
                params["RequestId" /* InstrumentationParam.RequestId */] =
                    getRequestIdFromResponse(response) || '';
            },
        }).then(function (response) {
            logger === null || logger === void 0 ? void 0 : logger.ULS.sendTraceTag(0x1e8cf3de /* tag_49pp4 */, LogCategory.msoulscat_Wac_UnifiedUiHost, TraceLevel.Info, "Create new fileType: ".concat(fileType, ", httpStatus: ").concat(response.status, ", httpResponse: ").concat(response));
            var item = response.data;
            if (item && item.id && item.webUrl) {
                return item;
            }
            else {
                throw logErrorEvent('Could not parse drive item from Graph response');
            }
        }, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (error) {
            var _a;
            logger === null || logger === void 0 ? void 0 : logger.ULS.sendTraceTag(0x1e8ce68a /* tag_49o0k */, LogCategory.msoulscat_Wac_UnifiedUiHost, TraceLevel.Info, "Create new fileType: ".concat(fileType, ", error: ").concat(error));
            var params = (_a = {},
                _a["ResourceId" /* InstrumentationParam.ResourceId */] = correlationId,
                _a["Error" /* InstrumentationParam.Error */] = error,
                _a);
            logErrorEvent(KnownInstrumentationEvents.WacDocumentVroomError, params);
            return undefined;
        });
    }
}
//# sourceMappingURL=createNewFile.js.map